import axios from 'axios';
import resolve  from './../resolver.js';
import checkJwt from './../../Global/jwtChecker';
import logout from './../../Global/logout';

export default async function GetClientTypes(
    countryUuid
) {

    const unHashedJwt = await checkJwt()

    if(!unHashedJwt){
        logout()
    }

    return await resolve(
        axios( process.env.REACT_APP_DEFAULT_API_PREFIX + 'provider/client/type/list?countryUuid=' + countryUuid, {
            method: 'get',
            headers: { 'Authorization' : unHashedJwt}           
        }).then(res => res.data)
        .catch(error => error.response.data.status === 401 ? logout() : error.response)
    );
}